import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Icon } from '@iconify/react';
import { getSuccessPageStyles } from './successPageStyles';
import { useEventRegistrationTranslation } from '@ui/layout/EventRegistration/hooks/useEventRegistrationTranslation';
import { VideoControlButton } from '@ui/layout/EventRegistration/VideoControlButton';
import { useAppSelector } from '@application/store/useStore';
import DOMPurify from 'dompurify';
const EventRegistrationSuccess = ({ previewLayout }) => {
    const styles = useMemo(() => getSuccessPageStyles(previewLayout), [previewLayout]);
    const { t } = useEventRegistrationTranslation();
    const { VDKEventForRegistration } = useAppSelector((state) => state.VDKEvent);
    const isEmptyHtml = (htmlString) => {
        if (!htmlString)
            return true;
        const cleanText = htmlString.replace(/<[^>]*>/g, '').trim();
        return cleanText === '';
    };
    const hasCustomMessage = Boolean(VDKEventForRegistration?.thankYouText) &&
        !isEmptyHtml(VDKEventForRegistration?.thankYouText);
    const sanitizedThankYouMessage = DOMPurify.sanitize(VDKEventForRegistration?.thankYouText ?? '');
    return (_jsx(Box, { sx: styles.root, children: _jsxs(Box, { sx: styles.card, children: [_jsx(VideoControlButton, { sx: styles.playIcon }), _jsx(Box, { sx: styles.iconWrap, children: _jsx(Icon, { icon: 'eva:checkmark-fill', width: 36, height: 36 }) }), hasCustomMessage ? (_jsx(Box, { className: 'ql-editor', sx: styles.customMessage, dangerouslySetInnerHTML: { __html: sanitizedThankYouMessage } })) : (_jsx(Typography, { sx: styles.title, children: t('eventRegistration.success.title') }))] }) }));
};
export default EventRegistrationSuccess;
